export type MillListHeaders = {
    label:
        | 'Código'
        | 'Nome Fantasia'
        | 'Razão Social'
        | 'Bloqueio de fábrica'
        | ''
    value: 'legacyCode' | 'name' | 'corporateName' | 'isBlocked' | 'icons'
}
export type MillBlockHistoryListHeaders = {
    label:
        | 'Data de Modificação'
        | 'Usuário responsável'
        | 'Status da modificação'
        | 'Motivo do bloqueio (quando status ATIVO)'
    value: 'createdAt' | 'userName' | 'status' | 'reason'
}

export const avaliableUfs = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
]

export type MillForm = {
    legacyCode: string
    name: string
    corporateName: string
    uf: string
}

export type ConfigForm = {
    allowsOrderEdition: boolean
    stockSafetyDays?: number
    allowsOrderOutOfPricePolicy: boolean
    chapaValue?: number
    usePallet: boolean
    useChapa: boolean
    allowsCustomDeadline: boolean
    millBlockHistory: MillBlockHistory[]
    isBlocked?: boolean
    reason?: string
}

export enum TypeForm {
    Mill = 1,
    Config,
}

export type CommercialRulesListHeaders = {
    label:
        | 'Categoria'
        | 'Titulo do comunicado'
        | 'Disponibilidade'
        | 'Documento'
        | 'Opções'
    value: 'type' | 'title' | 'active' | 'path' | 'icons'
    hasSwapVertIcon: boolean
}

export type MillBlockHistoryStatus = 'ativo' | 'inativo'

export type User = {
    name: string
    legacyCode: string
    email: string
    role: string
}
export type MillBlockHistory = {
    id?: string
    millId: string
    userId?: string
    user?: User
    reason: string
    createdAt: Date
    status: MillBlockHistoryStatus
}
